import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { MenuButton, IconButton } from '@chakra-ui/react';
import { ButtonGroup } from '../ButtonGroup/component.js';
import { DropdownMenu } from '../DropdownMenu/component.js';
import Button from '../Button/component.js';
import { Icon } from '../Icon/component.js';
var SplitButton = function SplitButton(_ref) {
  var colorScheme = _ref.colorScheme,
    onClick = _ref.onClick,
    variant = _ref.variant,
    label = _ref.label,
    leftIcon = _ref.leftIcon,
    isDisabled = _ref.isDisabled,
    size = _ref.size,
    _ref$menu = _ref.menu,
    items = _ref$menu.items,
    _ref$menu$placement = _ref$menu.placement,
    placement = _ref$menu$placement === undefined ? 'bottom-end' : _ref$menu$placement;
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    "data-object-type": "core-split-button",
    colorScheme: colorScheme,
    isDisabled: isDisabled,
    size: size,
    isAttached: true,
    variant: variant
  }, /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onClick
  }, leftIcon && {
    leftIcon: /*#__PURE__*/React.createElement(Icon, leftIcon)
  }), label), /*#__PURE__*/React.createElement(DropdownMenu, {
    items: items,
    placement: placement,
    menuButton: /*#__PURE__*/React.createElement(MenuButton, {
      as: IconButton,
      icon: /*#__PURE__*/React.createElement(Icon, {
        prefix: 'fas',
        iconName: 'angle-down'
      })
    })
  }));
};
SplitButton.displayName = "SplitButton";
export { SplitButton };